module.exports = __webpack_public_path__ + "img/cat-lederhosen.e779435c.jpg";